export const getFileByLink = (link: string, fileName: string) => {
  const linkComponent = document.createElement("a");
  linkComponent.href = link;
  linkComponent.setAttribute("data-testid", "temporary-download-link");
  linkComponent.setAttribute("download", fileName);
  document.body.appendChild(linkComponent);
  linkComponent.click();
  linkComponent.remove();
};
